import Paper from './Paper'
export default Paper
export * from './Paper'
